import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';

import { weightUnitLabels, heightUnitLabels, shareMealsLabels } from '../../constants/labels';
import { getMobileUserDetails } from '../../actions/mobileUser';
import { countries, physicalActivityLabel, goalLabel} from '../../constants/labels';
import Menus from '../../components/Menus/Menus';
import Basket from '../../components/Basket/Basket';

import styles from './MobileUserDetails.module.css';
import { capitalizeFirstLetter } from '../../utils/functions';

const MobileUserDetails = (props) => {
  const {
    getMobileUserDetails,
    userDetails,
  } = props;

  const { id } = useParams();
  // const totalNutrients = {};

  useEffect(() => {
    getMobileUserDetails(id);
  }, []);

  if (!userDetails) {
    return false;
  }

  const renderMenuStatistic = () => {
    if (!userDetails.menus) {
      return;
    }

    // debugger;
    let uniqMenus = [];
    userDetails.menus.forEach((menu) => {
      const ids = _.map(menu, 'id').sort().join(',');
      uniqMenus.push(ids);
    });

    const uniqMenusAmount = _.uniq(uniqMenus).length;

    return (
      <div className={styles.infoRow}>
        Menus Statistic:{' '}
        start uniq - {userDetails.preMenus},
        end uniq - {uniqMenusAmount}
      </div>
    );
  };

  return (
    <div className="wrapper">
      <h1>
        Mobile user details
      </h1>
      <div className={styles.userDetails}>
        <div className={styles.leftPart}>
          <div className={styles.infoRow}>
            Name: {userDetails.name}
          </div>
          <div className={styles.infoRow}>
            Email: {userDetails.email}
          </div>
          <div className={styles.infoRow}>
            Country: {countries[userDetails.country] || '-'}
          </div>
          <div className={styles.infoRow}>
            Gender: {userDetails.gender ? (userDetails.gender === 'man' ? 'Male' : 'Female') : '-'}
          </div>
          <div className={styles.infoRow}>
            Date of birth: {userDetails.birth_date ? moment(userDetails.birth_date).format('DD/MM/YYYY') : '-'}
          </div>
          <div className={styles.infoRow}>
            Weight: {+userDetails.weight?.toFixed(2) || ''} {weightUnitLabels[userDetails.weight_unit] || '-'}
          </div>
          <div className={styles.infoRow}>
            Height: {+userDetails.height?.toFixed(2) || ''} {heightUnitLabels[userDetails.height_unit] || '-'}
          </div>
          <div className={styles.infoRow}>
            Physical activity: {physicalActivityLabel[userDetails.physical_activity] || '-'}
          </div>
          <div className={styles.infoRow}>
            <div>Exclude meals:</div>
            <div>{userDetails.exclude_meals || '-'}</div>
          </div>
          <div className={styles.infoRow}>
            <div>Allergies:</div>
            <div>{userDetails.allergies || '-'}</div>
          </div>
          <div className={styles.infoRow}>
            <div>Disliked products:</div> 
            <div>{userDetails.disliked_products || '-'}</div>
          </div>
          <div className={styles.infoRow}>
            Goal: {goalLabel[userDetails.goal] || '-'}
          </div>
          <div className={styles.infoRow}>
            Calories: {userDetails.calories ?  `${userDetails.calories} kcal` : '-'}
          </div>
          <div className={styles.infoRow}>
            Protein: {userDetails.protein ?  `${userDetails.protein} grams` : '-'}
          </div>
          <div className={styles.infoRow}>
            Fat: {userDetails.fat ?  `${userDetails.fat} grams` : '-'}
          </div>
          <div className={styles.infoRow}>
            Carbohydrates: {userDetails.carbohydrates ?  `${userDetails.carbohydrates} grams` : '-'}
          </div>
          <div className={styles.infoRow}>
            Is web: {userDetails.is_web ? 'Yes' : 'No'}
          </div>
          <div className={styles.infoRow}>
            Created at: {userDetails.created_at ? moment(userDetails.created_at).format('DD/MM/YYYY') : '-'}
          </div>
          <div className={styles.infoRow}>
            <strong>
              Additional Information
            </strong>
          </div>
          <div className={styles.infoRow}>
            Chronic diseases: {userDetails.chronic_diseases || '-'}
          </div>
          <div className={styles.infoRow}>
            Share meals: {shareMealsLabels[userDetails.share_meals] || '-'}
          </div>
          <div className={styles.infoRow}>
            Cooking prep: {userDetails.preparations_in_advance !== null ? (userDetails.preparations_in_advance ? 'Yes, I do' : 'No, I don’t') : '-'}
          </div>
          <div className={styles.infoRow}>
            Recipe level: {userDetails.prefers_complex_recipes !== null ? capitalizeFirstLetter(userDetails.prefers_complex_recipes) : '-'}
          </div>
          <div className={styles.infoRow}>
            Meals per day: {userDetails.meals_per_day || '-'}
          </div>
          <div className={styles.infoRow}>
            Alcoholic/fizzy drinks: {userDetails.sweet_drinks !== null ? (userDetails.sweet_drinks > 3 ? 'More than 3' : userDetails.sweet_drinks) : '-'}
          </div>
          {renderMenuStatistic()}
        </div>
      </div>
      {userDetails.menus && <Menus menus={userDetails.menus} />}
      {userDetails.basket && <Basket basket={userDetails.basket} />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.mobileUser.mobileUserDetails,
});

const mapDispatchToProps = {
  getMobileUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileUserDetails);
